import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { useConditionTagClassNames } from './hooks/useConditionTagClassNames';
import { useConditionTag } from './hooks/useConditionTag';
import { ConditionTagRoot, ConditionTagLabel, ConditionTagValue, ConditionTagValueSegment, ConditionTagValueMoreLink, ConditionTagValueTailElement, ConditionTagCloseIconContainer } from './style';
import { CONDITION_TAG_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../utils/hooks';
import { Tooltip } from '../Tooltip';
export var ConditionTag = forwardRef(function ConditionTag(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(CONDITION_TAG_CLASS_PREFIX);
  var classNames = useConditionTagClassNames(CONDITION_TAG_CLASS_PREFIX, className);

  var _useConditionTag = useConditionTag(props, ref),
      rootProps = _useConditionTag.rootProps,
      closeButtonProps = _useConditionTag.closeButtonProps,
      label = _useConditionTag.label,
      valueHead = _useConditionTag.valueHead,
      valueTail = _useConditionTag.valueTail,
      hasTail = _useConditionTag.hasTail,
      tailLength = _useConditionTag.tailLength,
      enableCloseIcon = _useConditionTag.enableCloseIcon;

  return React.createElement(ConditionTagRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), React.createElement(ConditionTagLabel, {
    theme: theme,
    className: classNames.Label
  }, label), React.createElement(ConditionTagValue, {
    theme: theme,
    className: classNames.Value
  }, valueHead.map(function (item, index) {
    return React.createElement(ConditionTagValueSegment, {
      key: index,
      theme: theme,
      className: classNames.ValueSegment
    }, item);
  }), hasTail && React.createElement(ConditionTagValueSegment, {
    theme: theme,
    className: classNames.ValueSegment,
    moreItems: true
  }, React.createElement(Tooltip, {
    minWidth: 20,
    maxWidth: 70,
    trigger: React.createElement(ConditionTagValueMoreLink, {
      tag: "span",
      theme: theme,
      className: classNames.ValueMoreLink
    }, tailLength, " more")
  }, valueTail.map(function (item, index) {
    return React.createElement(ConditionTagValueTailElement, {
      theme: theme,
      className: classNames.ValueTailElement,
      key: index
    }, item);
  })))), enableCloseIcon && React.createElement(ConditionTagCloseIconContainer, Object.assign({}, closeButtonProps, {
    theme: theme,
    className: classNames.CloseIconContainer
  }), React.createElement(CancelIcon, {
    small: true
  })));
});
ConditionTag.defaultProps = {
  enableCloseIcon: true
};